import { render, staticRenderFns } from "./SignupModal.vue?vue&type=template&id=b4e9b4e2&scoped=true"
import script from "./SignupModal.vue?vue&type=script&lang=js"
export * from "./SignupModal.vue?vue&type=script&lang=js"
import style0 from "./SignupModal.vue?vue&type=style&index=0&id=b4e9b4e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.103.0__lodash@4.17.21_2265jmbezkun34f67h53nems6y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e9b4e2",
  null
  
)

export default component.exports